import { useTranslation } from 'react-i18next';
import { Icon } from '@/common/components/Icons/Icon';
import { PLAN } from '@/common/constants/markets';
import { TPlan } from '@/common/constants/markets';
import { ROUTES } from '@/common/constants/routes';
import { useFeatures } from '@/common/integrations/feature-flag/feature-flag.hooks';
import { useGetDiscounts } from '@/common/integrations/menhir/employee/discounts/discounts.hooks';
import { useGetFlexibleBenefitsSummary } from '@/common/integrations/menhir/employee/flexible-benefits/flexible-benefits.hooks';
import { useGetInsurancePolicies } from '@/common/integrations/menhir/employee/insurance/insurance.hooks';
import { TabsWrapper } from './TabsWrapper/TabsWrapper';

export const ESTabsLayout = ({ plan = PLAN.ES_MEAL }: { plan: TPlan }) => {
  const { t } = useTranslation();
  const { discounts } = useGetDiscounts();
  const { policies, upcomingPolicy } = useGetInsurancePolicies({
    enabled: plan !== PLAN.ES_MEAL,
  });
  const { error, isInitialLoading } = useGetFlexibleBenefitsSummary({
    enabled: plan === PLAN.ES_HYBRID,
  });
  const {
    features: { ff_employee_coverflex_ai },
  } = useFeatures();

  return (
    <TabsWrapper
      items={[
        {
          href: ROUTES.ROOT,
          label: t('navigation.home'),
          icon: <Icon icon="home" />,
          exact: true,
        },
        {
          href: ROUTES.MEAL,
          label: t('navigation.meal_card'),
          icon: <Icon icon="utensils" />,
          exact: true,
          hidden: plan !== PLAN.ES_MEAL,
        },
        {
          href: ROUTES.BENEFITS,
          label: t('navigation.benefits'),
          icon: <Icon icon="seedling" />,
          hidden:
            plan === PLAN.ES_MEAL ||
            isInitialLoading ||
            error?.statusCode === 404,
        },
        {
          href: ROUTES.INSURANCE,
          label: t('navigation.insurance'),
          icon: <Icon icon="shield-plus" />,
          hidden: !policies?.length && !upcomingPolicy,
        },
        {
          href: ROUTES.DISCOUNTS,
          label: t('navigation.discounts'),
          icon: <Icon icon="tags" />,
          hidden: discounts?.length === 0,
          sidebar: true,
        },
        {
          href: ROUTES.COVERFLEX_AI,
          label: t('navigation.coverflex_ai'),
          icon: <Icon icon="sparkles" />,
          hidden: !ff_employee_coverflex_ai,
          sidebar: true,
        },
        {
          href: ROUTES.PROFILE,
          label: t('navigation.profile'),
          icon: <Icon icon="user" />,
          sidebar: true,
        },
      ]}
    />
  );
};
